import { request } from "../../api";

export type MailProvider = "log" | "resend" | "smtp" | "ses";

/** What the server will send through. Secrets are write-only. */
export interface MailConfig {
  provider: MailProvider;
  from: string;
  smtpHost?: string;
  smtpPort?: number;
  smtpUser?: string;
  smtpTls?: "starttls" | "implicit" | "none";
  /** A key or password is stored; its value is never returned. */
  hasCredential: boolean;
  /** Someone has saved a provider on this screen. */
  configured: boolean;
  configuredAt?: string;
  /** Where the settings in use come from: saved here, the deployment the services started with, or nothing. */
  source?: "saved" | "deployment" | "";
}

export interface MailConfigInput {
  provider: MailProvider;
  from: string;
  resendApiKey?: string;
  smtpHost?: string;
  smtpPort?: number;
  smtpUser?: string;
  smtpPassword?: string;
  smtpTls?: "starttls" | "implicit" | "none";
}

export const mailAdminApi = {
  config: () => request<MailConfig>("/v1/admin/mail/config"),
  save: (body: MailConfigInput) => request<MailConfig>("/v1/admin/mail/config", { method: "PUT", body }),
  test: (to: string, mail: MailConfigInput) => request<{ ok: true }>("/v1/admin/mail/test", { method: "POST", body: { to, mail } }),
};

export const mailAdminKeys = { config: ["admin", "mail-config"] as const };
